import EnvironmentService from "../services/EnvironmentService.js";
const MigrationErrorMessages = {
  MethodNotAllowed: () => EnvironmentService.wsplitMethodNotAllowedText() || "This resource is being migrated and cannot be updated.",
  NotAcceptable: () => EnvironmentService.wsplitNotAcceptableText() || "This resource has been migrated and cannot be edited.",
  MovedPerminenty: "This resource has been migrated."
};
export {
  MigrationErrorMessages
};
//# sourceMappingURL=WorkspaceMigration.constants.js.map
